export default __webpack_public_path__ + "static/media/avalon-alpharetta-night.19085b95.jpg";